<div class="row">
  <div class="col-lg-4">
    <div class="row mt-2 mb-2">
      <div class="col-lg-5 text-right pr-0">
        <label class="label_cls">
          Named Insured:
        </label>
      </div>
      <div class="col-lg-7 pr-0 edit_cls">
        <label class="data_cls" *ngIf="clientData?.insuredName && !isEditControls?.insuredName">
          {{clientData?.insuredName ? clientData?.insuredName : '-'}}
        </label>
        <div class="data_cls" *ngIf="isEditControls?.insuredName">
          <div  class="data_cls_edit">
            <input type="text" class="data_input_edit mb-1 form-control" [(ngModel)]="clientData.insuredName">
          </div>
        </div>
        <a  class="ml-lg-2 mt-lg-1" *ngIf="clientData?.insuredName">
          <i class="fa fa-pencil-square-o" *ngIf="isEditControls?.insuredName ===undefined || !isEditControls?.insuredName" aria-hidden="true" (click)="editTheDetails('insuredName')"></i>
          <i class="fa fa fa-check-square-o mar_top11" *ngIf="isEditControls?.insuredName" aria-hidden="true" (click)="skipEdit('insuredName')"></i>
        </a>
      </div>
    </div>
    <div class="row mt-2 mb-2">
      <div class="col-lg-5 text-right pr-0">
        <label class="label_cls">
          Jobsite Address:
        </label>
      </div>
      <div class="col-lg-7 pr-0 edit_cls">
        <div class="data_cls" *ngIf="!isEditControls?.Address">
        <label class="data_cls_edit" *ngFor="let jobAdd of clientData?.jobsiteAddress">
          {{jobAdd?.addressLine1}}{{jobAdd?.addressLine2 }}<br>
          {{jobAdd?.city }},{{jobAdd?.state}}
          {{jobAdd?.zip}}          
        </label>
      </div>
      <div class="data_cls" *ngIf="isEditControls?.Address">
        <div  class="data_cls_edit " *ngFor="let jobAdd of clientData?.jobsiteAddress">
          <input type="text" class="data_input_edit mb-1 form-control" [(ngModel)]="jobAdd.addressLine1">
          <input type="text" class="data_input_edit mb-1 form-control" [(ngModel)]="jobAdd.addressLine2">
          <input type="text" class="data_input_edit mb-1 form-control" [(ngModel)]="jobAdd.city">
          <input type="text" class="data_input_edit mb-1 form-control" [(ngModel)]="jobAdd.state">
          <input type="text" class="data_input_edit mb-1 form-control" [(ngModel)]="jobAdd.zip">
        </div>
      </div>
      <label class="data_cls" *ngIf="!clientData?.jobsiteAddress || clientData?.jobsiteAddress?.length==0">-</label>
      <a class="ml-lg-2 mt-lg-1">
        <i class="fa fa-pencil-square-o" *ngIf="isEditControls?.Address ===undefined || !isEditControls?.Address" aria-hidden="true" (click)="editTheDetails('Address')"></i>
        <i class="fa fa fa-check-square-o mar_top11" *ngIf="isEditControls?.Address" aria-hidden="true" (click)="skipEdit('Address')"></i>
      </a>
        <!-- <label class="data_cls" *ngIf="!clientData?.jobsiteAddress || clientData?.jobsiteAddress?.length==0">-</label>
        <a href="#" class="ml-lg-3 mt-lg-1" *ngIf="clientData?.jobsiteAddress">
          <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
        </a> -->
      </div>
    </div>
    <div class="row mt-2 mb-2">
      <div class="col-lg-5 text-right pr-0">
        <label class="label_cls">Line of Business:</label>
      </div>
      <div class="col-lg-6 pr-0">
        <label class="data_cls">
          {{clientData?.lineOfBusiness ? clientData?.lineOfBusiness : '-'}}</label>
      </div>
      
    </div>

  </div>
  <div class="col-lg-5 offset-lg-1 float-right text-right">
    <div class="row mt-2 mb-3">
      <div class="col-lg-5 text-right pr-0">
        <label class="label_cls">Policy Period:</label>
      </div>
      <div class="col-lg-6 pr-0" *ngIf="!isEditControls?.PolicyPeriod">
        <label class="data_cls">
          {{clientData?.policyStartDate ? (clientData?.policyStartDate | date : 'MM/dd/yyyy'): ''}}-
          {{clientData?.policyEndDate ? (clientData?.policyEndDate | date : 'MM/dd/yyyy'): ''}}
        </label>       
      </div>

      <div class="col-lg-6 pr-0" *ngIf="isEditControls?.PolicyPeriod">
        <div class="data_cls" style="float: left;" >
          <p-calendar class="mb-1 date_cntrl" [showIcon]="true" inputId="icon" [(ngModel)]="clientData.policyStartDate"></p-calendar>
          <p-calendar class="mb-1" [showIcon]="true" inputId="icon" [(ngModel)]="clientData.policyEndDate"></p-calendar>
        </div>
      </div>
      
      <div class="col-lg-1 p-0 edit_cls" *ngIf="clientData?.policyStartDate && clientData?.policyEndDate">
        <!-- <a href="#"><i class="fa fa-pencil-square-o" aria-hidden="true"></i></a> -->
        <a class="ml-lg-2 mt-lg-1">
          <i class="fa fa-pencil-square-o" *ngIf="isEditControls?.PolicyPeriod ===undefined || !isEditControls?.PolicyPeriod" aria-hidden="true" (click)="editTheDetails('PolicyPeriod')"></i>
          <i class="fa fa fa-check-square-o mar_top11" *ngIf="isEditControls?.PolicyPeriod" aria-hidden="true" (click)="skipEdit('PolicyPeriod')"></i>
        </a>
      </div>
    </div>
  </div>
</div>

<div class="row mt-2 mb-3 m-0">
  <div class="col-lg-12">
    <span class="heading_cls">Addresses</span>
    <a class="add_new"  data-toggle="modal" data-target="#ApplychangesModal">Add New</a>
  </div>
  <div class="col-lg-7 mt-3">
    <div class="row m-0">
      <div class="col-lg-6 border_right">
        <div class="Address_cls">Mailing Address
          <span class="edit_icon" *ngIf="clientData?.mailingAddress?.length>0">
            <!-- <a href="#"><i class="fa fa-pencil-square-o" aria-hidden="true"></i></a> -->
            <a class="ml-lg-2 mt-lg-1">
              <i class="fa fa-pencil-square-o" *ngIf="isEditControls?.Mail ===undefined || !isEditControls?.Mail" aria-hidden="true" (click)="editTheDetails('Mail')"></i>
              <i class="fa fa fa-check-square-o" *ngIf="isEditControls?.Mail" aria-hidden="true" (click)="skipEdit('Mail')"></i>
            </a>
          </span>
          <span class="delete_icon" *ngIf="clientData?.mailingAddress?.length>0">
            <a>
              <i class="fa fa-trash" aria-hidden="true" (click)="deleteInformation(clientData?.mailingAddress,'Mail')"></i></a>
          </span>
        </div>
        <div class="data_cls" *ngIf="!isEditControls?.Mail">
        <label class="data_cls" *ngFor="let mailAdd of clientData?.mailingAddress">
          {{mailAdd?.addressLine1}}{{mailAdd?.addressLine2}}<br>
          {{mailAdd?.city}},{{mailAdd?.state}}
          {{mailAdd?.zip}}
        </label>
      </div>
      <div class="data_cls" *ngIf="isEditControls?.Mail">
        <div  *ngFor="let mailAdd of clientData?.mailingAddress">
          <input type="text" class="data_input_edit mb-1 form-control" [(ngModel)]="mailAdd.addressLine1">
          <input type="text" class="data_input_edit mb-1 form-control" [(ngModel)]="mailAdd.addressLine2">
          <input type="text" class="data_input_edit mb-1 form-control" [(ngModel)]="mailAdd.city">
          <input type="text" class="data_input_edit mb-1 form-control" [(ngModel)]="mailAdd.state">
          <input type="text" class="data_input_edit mb-1 form-control" [(ngModel)]="mailAdd.zip">
        </div>
      </div>
        <label class="data_cls" *ngIf="!clientData?.mailingAddress || clientData?.mailingAddress?.length==0">-</label>
      </div>
      <div class="col-lg-6">
        <div class="Address_cls">Billing Address
          <span class="edit_icon" *ngIf="clientData?.billingAddress?.length>0">
            <!-- <a href="#"><i class="fa fa-pencil-square-o" aria-hidden="true"></i></a> -->
            <a class="ml-lg-2 mt-lg-1">
              <i class="fa fa-pencil-square-o" *ngIf="isEditControls?.Bill ===undefined || !isEditControls?.Bill" aria-hidden="true" (click)="editTheDetails('Bill')"></i>
              <i class="fa fa fa-check-square-o" *ngIf="isEditControls?.Bill" aria-hidden="true" (click)="skipEdit('Bill')"></i>
            </a>
          </span>
          <span class="delete_icon" *ngIf="clientData?.billingAddress?.length>0">
            <a><i class="fa fa-trash" aria-hidden="true" (click)="deleteInformation(clientData?.billingAddress,'Bill')"></i></a>
          </span>
        </div>
        <div class="data_cls" *ngIf="!isEditControls?.Bill">
        <label class="data_cls" *ngFor="let billAdd of clientData?.billingAddress">
          {{billAdd?.addressLine1}}{{billAdd?.addressLine2}}<br>
          {{billAdd?.city}},{{billAdd?.state}}
          {{billAdd?.zip}}
        </label>
      </div>
        <div class="data_cls" *ngIf="isEditControls?.Bill">
          <div class="data_cls" *ngFor="let billAdd of clientData?.billingAddress">
            <input type="text" class="data_input_edit mb-1 form-control" [(ngModel)]="billAdd.addressLine1">
            <input type="text" class="data_input_edit mb-1 form-control" [(ngModel)]="billAdd.addressLine2">
            <input type="text" class="data_input_edit mb-1 form-control" [(ngModel)]="billAdd.city">
            <input type="text" class="data_input_edit mb-1 form-control" [(ngModel)]="billAdd.state">
            <input type="text" class="data_input_edit mb-1 form-control" [(ngModel)]="billAdd.zip">
          </div>
        </div>
        <label class="data_cls" *ngIf="!clientData?.billingAddress || clientData?.billingAddress?.length==0">-</label>
      </div>
    </div>
  </div>
</div>

<div class="row mt-3 mb-2 m-0">
  <div class="col-lg-12">
    <span class="heading_cls">Additional Named Insured</span>
    <a class="add_new">Add New</a>
  </div>
  <div class="col-lg-5 mt-3 mb-2" >
    <div class="row m-0" *ngFor="let insured of clientData?.additionalInsured;trackBy: returnIndex;let idx=index">
      <div class="col-lg-6" *ngIf="!isEditControls?.AdditionalNamedInsured">
        <label class="data_cls text-left">{{insured ? insured : '-'}}</label>
      </div>

      <div class="col-lg-6" *ngIf="isEditControls?.AdditionalNamedInsured">
        <div class="data_cls">
          <div  class="data_cls_edit ">
              <input type="text" name="nameInsured_{{idx}}" class="data_input_edit mb-1 form-control" [(ngModel)]="clientData.additionalInsured[idx]">
          </div>
        </div>
      </div>
      <div class="col-lg-6 text-left">
        <span class="edit_icon">
          <a class="ml-lg-2 mt-lg-1">
            <i class="fa fa-pencil-square-o" *ngIf="isEditControls?.AdditionalNamedInsured ===undefined || !isEditControls?.AdditionalNamedInsured" aria-hidden="true" (click)="editTheDetails('AdditionalNamedInsured')"></i>
            <i class="fa fa fa-check-square-o mar_top11" *ngIf="isEditControls?.AdditionalNamedInsured" aria-hidden="true" (click)="skipEdit('AdditionalNamedInsured')"></i>
          </a>
          <!-- <a href="#"><i class="fa fa-pencil-square-o" aria-hidden="true"></i></a> -->
        </span>
        <span class="delete_icon">
          <a><i class="fa fa-trash" aria-hidden="true" (click)="deleteInformation(clientData.additionalInsured,'AdditionalNamedInsured')"></i></a>
        </span>
      </div>
    </div>
    <div class="col-md-12">
      <label class="data_cls" *ngIf="!clientData?.additionalInsured">-</label>
    </div>
  </div>
</div>

<div class="row mt-2 mb-3 m-0">
  <div class="col-lg-12">
    <span class="heading_cls">Billing Payment Plan</span>
    <span class="head_edit_icon">
      <!-- <a href="#"><i class="fa fa-pencil-square-o" aria-hidden="true"></i></a> -->
      <a class="ml-lg-2 mt-lg-1">
        <i class="fa fa-pencil-square-o" *ngIf="isEditControls?.BillingPaymentPlan ===undefined || !isEditControls?.BillingPaymentPlan" aria-hidden="true" (click)="editTheDetails('BillingPaymentPlan')"></i>
        <i class="fa fa fa-check-square-o" *ngIf="isEditControls?.BillingPaymentPlan" aria-hidden="true" (click)="skipEdit('BillingPaymentPlan')"></i>
      </a>
    </span>
  </div>
  <div class="col-lg-10">
    <div class="row mt-3  ml-lg-2">
      <div class="col-lg-2 text-left pr-0">
        <label class="label_cls">
          Billing Option:
        </label>
      </div>
      <div class="col-lg-10 pr-0">
        <label class="data_cls" *ngIf="!isEditControls?.BillingPaymentPlan">
          {{clientData?.billingOption ? clientData?.billingOption : '-'}}
        </label>
        <div class="data_cls" *ngIf="isEditControls?.BillingPaymentPlan">
          <input type="text" class="data_cls form-control" [(ngModel)]="clientData.billingOption">
        </div>
      </div>
    </div>
    <div class="row mt-1 mb-2 ml-lg-2">
      <div class="col-lg-2 text-left pr-0">
        <label class="label_cls">
          Payment Plan:
        </label>
      </div>
      <div class="col-lg-10 pr-0">
        <label class="data_cls" *ngIf="!isEditControls?.BillingPaymentPlan">
          {{clientData?.paymentPlan ? clientData?.paymentPlan : '-'}}
        </label>
        <div class="data_cls" *ngIf="isEditControls?.BillingPaymentPlan">
          <input type="text" class="data_cls form-control" [(ngModel)]="clientData.paymentPlan">
        </div>
      </div>     
    </div>
  </div>
</div>

<div class="row mt-2 mb-3 ">
  <div class="col-lg-12 ml-lg-3">
    <span class="heading_cls">Blanket Additional Insured</span>
  </div>
  <div class="col-lg-4">
    <div class="row mt-3 ml-lg-0">
      <div class="col-lg-6 text-right pr-0">
        <label class="label_cls">
          Has Blanket Insured:
        </label>
      </div>
      <div class="col-lg-6 pr-0">        
        <div class="d-flex">
          <label class="data_cls pr-4" *ngIf="!isEditControls?.HasBlanketInsured">
            {{clientData?.isBlanketInsured ? 'Yes' : 'No'}}
          </label>
        <div class="p-field-radiobutton" *ngIf="isEditControls?.HasBlanketInsured">
          <p-radioButton name="Yes" value="Yes" inputId="Yes" [(ngModel)]="clientData.isBlanketInsured"></p-radioButton>
          <label class="p_radiobtn_labelcls" for="Yes1"><b>Yes</b></label>
          <p-radioButton name="No" value="No" inputId="No" [(ngModel)]="clientData.isBlanketInsured"></p-radioButton>
          <label class="p_radiobtn_labelcls" for="No1"><b>No</b></label>
        </div>
        <span class="blanket_edit_icon">
          <a class="ml-lg-2 mt-lg-1"><i class="fa fa-pencil-square-o" *ngIf="isEditControls?.HasBlanketInsured ===undefined || !isEditControls?.HasBlanketInsured" aria-hidden="true" (click)="editTheDetails('HasBlanketInsured')"></i>
          <i class="fa fa fa-check-square-o" *ngIf="isEditControls?.HasBlanketInsured" aria-hidden="true" (click)="skipEdit('HasBlanketInsured')"></i>
          </a>
          <!-- <a href="#"><i class="fa fa-pencil-square-o" aria-hidden="true"></i></a> -->
        </span>
      </div>
       
      </div>
    </div>

  </div>
</div>

<div class="row mt-2 mb-3 m-0">
  <div class="col-lg-12">
    <span class="heading_cls">Addtional Interest Types</span>
    <a class="add_new">Add New</a>
  </div>
  <div class="col-lg-10">
    <div class="row mt-3 ml-0 mr-0">
      <div class="col-lg-2 text-right pr-0">
        <label class="label_cls">
          Interest Type:
        </label>
      </div>
      <div class="col-lg-9 pr-0">
        <label class="data_cls pr-4" *ngIf="clientData?.interestTypes?.length>0 ">
          {{clientData?.interestTypes[0]?.interestType ? clientData?.interestTypes[0]?.interestType : '-'}}
        </label>
        <label class="data_cls pr-4"
          *ngIf="!clientData?.interestTypes || clientData?.interestTypes?.length ===0">-</label>
        <span class="addional_icon" *ngIf="clientData?.interestTypes?.length>0">
          <span class="edit_icon mr-1">
            <a href="#"><i class="fa fa-pencil-square-o" aria-hidden="true"></i></a>
          </span>
          <span class="delete_icon">
            <a href="#"><i class="fa fa-trash" aria-hidden="true"></i></a>
          </span>
        </span>
      </div>

    </div>
    <div class="row mt-2 ml-0 mr-0">
      <div class="col-lg-2 text-right pr-0">
        <label class="label_cls">
          Business Name:
        </label>
      </div>
      <div class="col-lg-9 pr-0">
        <label class="data_cls pr-4">
          {{clientData?.interestTypes[0]?.businessName ? clientData?.interestTypes[0]?.businessName : '-'}}
        </label>
      </div>
    </div>
    <div class="row mt-2 ml-0 mr-0">
      <div class="col-lg-2 text-right pr-0">
        <label class="label_cls">
          Address:
        </label>
      </div>
      <div class="col-lg-9 pr-0">
        <label class="data_cls pr-4"
          *ngIf="clientData?.interestTypes?.length>0 && clientData?.interestTypes[0]?.addressInfo?.length>0">
          {{clientData?.interestTypes[0]?.addressInfo[0]?.addressLine1 ? clientData?.interestTypes[0]?.addressInfo[0]?.addressLine1 : '-  '}}{{clientData?.interestTypes[0]?.addressInfo[0]?.addressLine2 ? clientData?.interestTypes[0]?.addressInfo[0]?.addressLine2 : '-'}}<br>
          {{clientData?.interestTypes[0]?.addressInfo[0]?.city ? clientData?.interestTypes[0]?.addressInfo[0]?.city : '-'}},{{clientData?.interestTypes[0]?.addressInfo[0]?.state ? clientData?.interestTypes[0]?.addressInfo[0]?.state : '-'}}
          {{clientData?.interestTypes[0]?.zip ? clientData?.interestTypes[0]?.addressInfo[0]?.zip : '-'}}
        </label>
        <label class="data_cls pr-4"
          *ngIf="!clientData?.interestTypes || !clientData?.interestTypes[0]?.addressInfo">-</label>
      </div>
    </div>

  </div>
</div>

<div class="row mt-3">
  <div class="col-md-12 ">
    <div class="col-md-12 evdbtn border_top_1 pt-3 text-right">
      <button pButton type="button" class="btn btn-primary mt-0 mr-0 cancel_btn font-600" label="Cancel" (click)="skipAllEdit()"></button>
    </div>
  </div>
</div>
<!--Apply Change Modal Modal-->
<div class="modal fade small_modal" id="ApplychangesModal" tabindex="-1" role="dialog"
  aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-top " role="document">
    <div class="modal-content appchngmdl">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Apply Changes</h5>
        <button class="close" type="button" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="modal-body mt-3 mb-2">
        <div class="row mb-3">
          <div class="col-md-12 apply_changes d-flex">
            <div class="col-md-5 text-right">
              <b>Amend Reason(s):</b>
            </div>
            <div class="col-md-7 text-left">
              Additional Named Insured
            </div>
          </div>
        </div>
        <div class="row mt-4 mb-3">
          <div class="col-md-12 apply_changes d-flex">
            <div class="col-md-5 text-right">
              <b>Effective Date:</b>
            </div>
            <div class="col-md-7 text-left">
              <input type="date" name="efday" max="3000-12-31" min="1000-01-01" value="08/12/2020" class="form-control">
            </div>
          </div>
        </div>

        <div class="row mt-4 mb-0">
          <div class="col-md-12 apply_changes d-flex">
            <div class="col-md-5 text-right">
              <b>Expiration Date:</b>
            </div>
            <div class="col-md-7 text-left">
              <input type="date" name="Eday" value="08/12/2020" class="form-control">
            </div>
          </div>
        </div>

      </div>
      <div class="row m-0">
        <div class="col-md-12 p-0 mb-2">
          <div class="modal-footer border_top_none">
            <!-- <button class="btn btn-secondary" type="button" data-dismiss="modal">Cancel</button> -->
            <a class="btn btn-primary save_btn mr-2" href="#">Save</a>
            <a class="btn btn-primary" href="#">Cancel Changes</a>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>